export const GET_DOMAINS = 'GET_DOMAINS';
export const GET_DOMAINS_REQUEST = 'GET_DOMAINS_REQUEST';
export const SET_CURENT_DOMAIN = 'SET_CURENT_DOMAIN';
export const SET_CURENT_TYPE = 'SET_CURENT_TYPE';
export const SET_CURENT_SELECTED_TYPE = 'SET_CURENT_SELECTED_TYPE';

export const RESET_STATE = 'RESET_STATE';
export const TOGLE_DATA_TYPE_MODAL = 'TOGLE_DATA_TYPE_MODAL';
export const SET_DATA_TYPE_LIST = 'SET_DATA_TYPE_LIST';
